import { render, staticRenderFns } from "./PdfPageSwitch.vue?vue&type=template&id=1621dc99"
import script from "./PdfPageSwitch.vue?vue&type=script&lang=js"
export * from "./PdfPageSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports